export const en = {
  assignedTo: 'ASSIGNED TO:',
  unassigned: 'Unassigned',
  searchForUser: 'Search for a user',
  noResults: 'no results',
  noMatchingUsers: 'No matching users found.',
  assignUser: 'Assign user',
  assignUpgrade: 'Upgrade to assign guests',
  assignTaskToClient: 'Assign this task to a Client?',
  visibleTo: 'This task will become visible to both\n',
  membersAndClients: 'Members and Clients',
  assignToClient: 'Assign to Client',
  cancel: 'Cancel'
};

export type Translations = typeof en;
